export default {
    product: {
        description: {
            more: "more"
        },
        added: "Added to Cart"
    }
}